import type { Project, ScrollControl } from '@goanna-im/shared';
import { useVoiceFollow } from '../lib/useVoiceFollow.js';

/**
 * EXPERIMENTAL voice-follow control for the producer console. Listens on this
 * device (needs Chrome + secure context) and moves the presenter to your place.
 */
export function VoiceFollowPanel({
  project,
  onScroll,
  anchorBlockId,
}: {
  project: Project;
  onScroll: (control: ScrollControl) => void;
  anchorBlockId?: string;
}) {
  const vf = useVoiceFollow(project, onScroll, anchorBlockId);

  return (
    <section className="card stack">
      <h3>🎤 Voice-follow (experimental)</h3>
      {!vf.supported ? (
        <p className="muted" style={{ margin: 0 }}>
          Needs a Chrome-family browser in a secure context (localhost or HTTPS). Not available in
          this browser/context.
        </p>
      ) : (
        <>
          <p className="muted" style={{ margin: 0, fontSize: '0.85rem' }}>
            Reads the script as you speak and moves the presenter to your place. Holds when you go
            off-script; manual scroll and the remote always still work.
          </p>
          <div className="row" style={{ justifyContent: 'space-between' }}>
            <button className={vf.active ? 'danger' : 'primary'} onClick={vf.toggle}>
              {vf.active ? '■ Stop listening' : '● Start listening'}
            </button>
            <span className="tag readout">{vf.status}</span>
          </div>
          <span className="tag readout">Heard: {vf.heard || '—'}</span>
          <span className="tag readout">
            Tracking: {vf.trackingBlock ? `block ${vf.trackingBlock} / ${vf.totalBlocks}` : '—'}
          </span>
        </>
      )}
    </section>
  );
}
